import axios from 'axios';
import EventBus from '@/event-bus';
import NProgress from 'nprogress';

const qs = require('qs');

const instance = axios.create();

instance.defaults.baseURL = process.env.API_URL || 'http://local.business.colektia.com/api';

instance.interceptors.request.use((config) => {
  NProgress.start();
  const method = config.method.toUpperCase();
  if (method === 'PUT' || method === 'PATCH' || method === 'DELETE') {
    // eslint-disable-next-line
    config.headers.common['X-HTTP-Method-Override'] = method;
    // eslint-disable-next-line
    config.method = 'post';
  }
  return config;
}, error => Promise.reject(error));

instance.interceptors.request.use((config) => {
  NProgress.start();

  // eslint-disable-next-line
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('default_auth_token')}`;

  return config;
}, error => Promise.reject(error));

instance.interceptors.response.use(() => {
  NProgress.done();
}, (error) => {
  NProgress.done();
  if (error.response.status === 401 && window.location.href !== '/login' && window.location.href !== '/register') {
    window.location.href = '/login';
  }
  if (error.response.status === 403) {
    EventBus.$emit('modal', 'No tiene permisos para realizar esta acción');
    window.location.href = '/company';
  }
  if (error.response.status === 422) {
    EventBus.$emit('sidebarFormError', error.response.data.errors);
  }
  return Promise.reject(error);
});

export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    EventBus.$on(this.sideBarFormBus.sidebarFormError, ($errors) => {
      Object.keys($errors).forEach((key) => {
        this.errors.add({
          field: key,
          msg: $errors[key][0],
        });
      });
    });
    EventBus.$on(this.sideBarFormBus.openRightDrawer, () => {
      Object.keys(this.form).forEach((key) => {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = '';
        }
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    });
  },
  beforeDestroy() {
    EventBus.$off(this.sideBarFormBus.sidebarFormError);
    EventBus.$off(this.sideBarFormBus.openRightDrawer);
  },
  data() {
    return {
      sideBarFormBus: {
        sidebarFormError: 'sidebarFormError',
        openRightDrawer: 'openRightDrawer',
        rightDrawerSaved: 'rightDrawerSaved',
        closeRightDrawer: 'closeRightDrawer',
      },
    };
  },
  methods: {
    save() {
      if (!this.edit) {
        instance.post(this.url, qs.stringify(this.form)).then(() => {
          EventBus.$emit(this.sideBarFormBus.rightDrawerSaved);
          EventBus.$emit(this.sideBarFormBus.closeRightDrawer);
        }).catch(() => {
          EventBus.$emit('modal', 'Ocurrio un error, pongase en contacto con soporte.');
        });
      } else {
        instance.patch(this.url, qs.stringify(this.form)).then(() => {
          EventBus.$emit(this.sideBarFormBus.rightDrawerSaved);
          EventBus.$emit(this.sideBarFormBus.closeRightDrawer);
        }).catch(() => {
          EventBus.$emit('modal', 'Ocurrio un error, pongase en contacto con soporte.');
        });
      }
    },
    close() {
      EventBus.$emit(this.sideBarFormBus.closeRightDrawer);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/sidebarForm.js